import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';

import { Location } from '@angular/common';

import momentJalaali from 'moment-jalaali';

import { DeviceDetectorService } from 'ngx-device-detector';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import * as XLSX from 'xlsx';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { filter, from, map, toArray } from 'rxjs';

declare let $: any;

@Component({

  selector: 'saveUser',

  templateUrl: './saveUser.component.html',

  styles: [

    `.modal tr.pointer:hover{

      background-color:#e0e7ff;

    }

            div.position-relative>label {
            background-color: white;
            position: absolute;
            right: 17px;
            top: -10px;
            padding: 0 10px;
            font-size: 14px;
            z-index: 2;
        }

        div.position-relative>input {
            color: navy;

        }

        div.position-relative>input:disabled {

            background-color: white !important;

        }

        .dropdown-container {
            position: initial;
            min-width: initial;
            border: none;
            display: flex !important;
            justify-content: end;
            align-items: center;
        }

        .dropdown-container button {
            background-color: transparent;
            border: none;
            padding-left: 6px;
        }

        .dropdown-menu {
            padding: 0;
            background-color: white;
            border-radius: 5px;
            box-shadow: 0 5px 10px hsl(0deg 0% 0% / 0.15),
                0 7px 15px hsl(0deg 0% 0% / 0.1),
                0 10px 20px hsl(0deg 0% 0% / 0.05),
                0 12px 25px hsl(0deg 0% 0% / 0.05);
        }

        .dropdown-li {
            display: flex;
            justify-content: start;
            align-items: center;
        }

        .dropdown-menu li {

            border-bottom: 1px solid #dedede;

            cursor: pointer;

            padding: 5px 10px;

            margin-top: 10px;

            margin-bottom: 10px;

            width: 200px;

        }

        .dropdown-menu li:hover {
            background-color: #dedede;
        }

        .dropdown-menu li:hover .fa,
        .dropdown-menu li:hover span {
            color: #00ADB5;
        }

        .dropdown-menu li span {

            display: flex;

            align-items: center;

            font-size: 13px;

        }

        .dropdown-menu li .fa {

            margin: 0 5px;

            padding-left: 10px;

            font-size: 19px;

        }
    
    `

  ]

})

export class SaveUserComponent implements OnInit {

  isDektop: any;

  userList: any;

  fullUserList: any;

  addUserInp: boolean = false;

  editUserId: any;

  editMod: boolean = false;

  assignCarList: any;

  tempAssignCarList: any;

  fullAssignCarList: any;

  countBHas: any;

  iUserSystemUser: any;

  accessSystem: any;

  fullAccessSystem: any;

  bAcssess: any;

  userActivity: any = [];

  fullUserActivity: any = [];

  isSortName: boolean = false;

  isSortDate: boolean = false;

  isSortInput: boolean = false;

  isSortLastLogin: boolean = false;

  fileName: any = "مدیریت کاربران.xlxs"

  filterAddTh: boolean = false;

  bSchool: boolean = false;

  list_schools: any = [];

  list_search = [];

  lst_Roles: any[] = [];

  lst_Grade: any[] = [];

  lst_ClassNo: any[] = [];

  lst_GradeClass: any[] = [];

  iSystemUser_School: string = '';

  iSystemUser: number = -1;

  sendSmsModel: FormGroup = this.formBuilder.group({
    iUserSystemUser: new FormControl(),
    strSMS: new FormControl(""),
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
  });

  saveUser: FormGroup = this.formBuilder.group({
    iMaxInput: new FormControl(),
    strUserName: new FormControl(),
    iMaxMobile: new FormControl(1),
    strMobile: new FormControl(),
    strEsterakEndDate: new Date().valueOf(),
    strFullName: new FormControl(),
    strPassword: new FormControl(),
    bEnable: new FormControl("true"),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
  });

  mdl_SystemUser_Group: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iUserSystemUser: new FormControl(""),

    iSystemUser_Group: new FormControl(""),

  });

  mdl_UserClass: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iUserSystemUser: new FormControl(""),

    iMobileDomain: new FormControl("-1"),

    tiGrade: new FormControl("-1"),

    tiClassNo: new FormControl("-1"),

  });

  constructor(private notifyService: NotificationService,
    private router: Router,
    public otherService: OtherService,
    private el: ElementRef,
    private deviceService: DeviceDetectorService,
    private formBuilder: FormBuilder,
    private _location: Location,
    private ActivatedRoute: ActivatedRoute,
    private gurdService: GurdServiceService


  ) {
    this.isDektop = this.deviceService.isDesktop();
  }

  ngOnInit(): void {

    this.ActivatedRoute.url.subscribe((segment) => {

      const router = segment[0].path;

      if (router == 'userSchool') this.bSchool = true;

      else this.getRoles()

      this.ActivatedRoute.params.subscribe(params => {

        if (params['iSystemUser'] != undefined) {

          this.iSystemUser = params['iSystemUser'];

          this.getSubset(params['iSystemUser']);


        }

        else this.getUser();

      });

      var data = window.localStorage.getItem('menu') as any;

      this.bAcssess = JSON.parse(this.gurdService.decrypt(data));

    })

    //Handel Close Modal

    $('#addUser').on('hidden.bs.modal', () => {
      this.addUserInp = false;
      this.editMod = false;
      this.saveUser.reset({
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
        strPassword: "",
        strFullName: "",
        iMaxInput: "",
        strMobile: "",
        bEnable: "true",
        strEsterakEndDate: momentJalaali().format('jYYYY/jMM/jDD'),
      });
      this.saveUser.controls['strMobile'].enable();
      this.saveUser.controls['strUserName'].enable();
    });

    $('#carModal').on('hidden.bs.modal', () => {
      $("#filterModal").val("");

      this.assignCarList = [];
      this.fullAssignCarList = [];
      this.filterAddTh = false;
    });

  }

  getRoles = async () => {

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    })

    this.otherService.Showspinner();

    const resp = await axios.post(`SystemUser_Group_List`, this.otherService.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);

    this.otherService.nonespinner();

    this.lst_Roles = res;


  }

  isNumber(e: any) {

    if (isNaN(e.key)) return false;

    return true;
  }

  getUser = async () => {

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      iLog_SystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    })

    this.otherService.Showspinner();

    // const resp = await axios.post(`GetRadyabUserUsers`, model);

    const resp = await axios.post(`GetRadyabUserUsers_New`, model);

    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    // this.userList = JSON.parse(resp.data);
    this.userList = resp.data;

    // this.fullUserList = JSON.parse(resp.data);
    this.fullUserList = resp.data;

  }

  filter(val: any) {

    this.userList = this.fullUserList.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strMobile_strComment.includes(val.value) ||

        el.strUserName.includes(val.value)

    });

    if (this.userList.length == 0) {

      this.userList = this.fullUserList.filter((el: any) => {

        return el.strUserName.includes(val.value);

      });


    }

  }

  sortByName() {
    this.isSortName = !this.isSortName;
    if (this.isSortName) {
      this.userList.sort((a: any, b: any) => {
        var textA = a.strFullName.toUpperCase();
        var textB = b.strFullName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
    }
    else {
      this.userList.sort((a: any, b: any) => {
        var textA = a.strFullName.toUpperCase();
        var textB = b.strFullName.toUpperCase();
        return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
      });
    }

  }

  sortByInput() {
    this.isSortInput = !this.isSortInput;
    if (this.isSortInput) {
      this.userList.sort(function (a: any, b: any) {
        return parseFloat(b.iInput) - parseFloat(a.iInput);
      });
    }
    else {
      this.userList.sort(function (a: any, b: any) {
        return parseFloat(a.iInput) - parseFloat(b.iInput);
      });
    }
  }

  sendSms = async () => {
    var model = this.sendSmsModel.value;
    model.iUserSystemUser = this.iUserSystemUser;
    const resp = await axios.post(`SendSMS2MobileUser`, model);
    resp.data = JSON.parse(resp.data);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    else {
      this.notifyService.showSuccess("با موفقیت ارسال شد");
      this.sendSmsModel.controls["strSMS"].setValue("");
    }
  }

  sortByDate() {
    this.isSortDate = !this.isSortDate;
    if (this.isSortDate) {
      this.userList.sort((a: any, b: any) => {
        return new Date(b.strEsterakEndDate) as any - (new Date(a.strEsterakEndDate) as any);
      });
    }
    else {
      this.userList.sort((a: any, b: any) => {
        return new Date(a.strEsterakEndDate) as any - (new Date(b.strEsterakEndDate) as any);
      });
    }
  }

  sortByLastLogin() {
    this.isSortDate = !this.isSortDate;
    if (this.isSortDate) {
      this.userList.sort((a: any, b: any) => {
        return new Date(b.strLastLoginDateTime) as any - (new Date(a.strLastLoginDateTime) as any);
      });
    }
    else {
      this.userList.sort((a: any, b: any) => {
        return new Date(a.strLastLoginDateTime) as any - (new Date(b.strLastLoginDateTime) as any);
      });
    }
  }

  filterCar(val: any) {
    this.assignCarList = this.fullAssignCarList.filter((el: any) => {
      return el.strFullName.includes(val.value);
    });

    if (this.assignCarList.length == 0) {
      this.assignCarList = this.fullAssignCarList.filter((el: any) => {
        return el.strUnitID.includes(val.value);
      });

    }
    if (this.assignCarList.length == 0) {
      this.assignCarList = this.fullAssignCarList.filter((el: any) => {
        return el.strSystemUser_strMobile.includes(val.value);
      });
    }

    if (this.assignCarList.length == 0) {
      this.assignCarList = this.fullAssignCarList.filter((el: any) => {
        return el.strMobileDomain_strComment.includes(val.value);
      });
    }
  }

  filterCarMobileDomain(val: any) {

    this.assignCarList = this.fullAssignCarList.filter((el: any) => {

      return el.strMobileDomain_strComment.includes(val.value);
    });
  }

  filterAccess(val: any) {
    this.fullAccessSystem = this.accessSystem.filter((el: any) => {
      return el.strComment?.includes(val.value);
    });
  }

  checkMobile = async () => {

    var model = this.saveUser.value;

    const resp = await axios.post(`CheckRadyabUserUser`, model);

    resp.data = JSON.parse(resp.data);

    if (resp.data.iResult == 0) {

      this.notifyService.showError(resp.data.strError);

      return;


    }

    if (resp.data.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    else {

      this.notifyService.showSuccess(resp.data.strError);

      this.addUserInp = true;

      this.saveUser.controls['strMobile'].disable();

      this.saveUser.controls['strUserName'].disable();

    }

  }

  addUser = async () => {

    this.saveUser.controls['strMobile'].enable();

    this.saveUser.controls['strUserName'].enable();

    var model = this.saveUser.value;

    const resp = await axios.post(`AddRadyabUser`, model);

    resp.data = JSON.parse(resp.data);

    if (!model.strFullName) {

      this.notifyService.showError("لطفا نام نام خانوادگی را وارد کنید");

      return;

    }

    if (!model.strPassword) {

      this.notifyService.showError("لطفا رمز عبور را وارد کنید");

      return;

    }

    if (!model.iMaxInput) {

      this.notifyService.showError("لطفا حداکثر تعداد ورود وارد کنید");

      return;

    }

    if (!model.iMaxMobile) {

      this.notifyService.showError("لطفا حداکثر تعداد خودرو وارد کنید");

      return;

    }

    if (resp.data.iResult == 0) {

      this.notifyService.showError(resp.data.strError);

      return;


    }
    if (resp.data.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    else {

      this.notifyService.showSuccess(resp.data.strError);

      $('#addUser').modal('hide');

      this.getUser();

    }


  }

  deleteUser = async (id: any) => {

    $.confirm({
      title: `آیا از حذف این کاربر اطمینان دارید؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "تایید",
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
              iSystemUser4Delete: id
            }
            const resp = await axios.post(`DeleteRadyabUser`, model);
            resp.data = JSON.parse(resp.data);
            if (resp.data.iResult == 0) {
              this.notifyService.showError(resp.data.strError);
              return;

            }
            if (resp.data.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              this.router.navigate(['login']);
              return;
            }
            else {
              this.notifyService.showSuccess("با موفقیت حذف شد");
              this.userList = this.userList.filter((el: any) => {
                return el.iSystemUser != id;
              });
              this.fullUserList = this.userList;
            }

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });




  }

  editUserModal(item: any) {
    this.saveUser.controls['strMobile'].disable();
    this.saveUser.controls['strUserName'].disable();

    this.addUserInp = true;
    this.saveUser.controls["iMaxInput"].setValue(item.iMaxInput);
    this.saveUser.controls["strMobile"].setValue(item.strMobile);
    this.saveUser.controls["strEsterakEndDate"].setValue(item.strEsterakEndDate);
    this.saveUser.controls["strFullName"].setValue(item.strFullName);
    this.saveUser.controls["strPassword"].setValue(item.strSipPassword);
    this.saveUser.controls["bEnable"].setValue(`${item.bEnable}`);
    this.saveUser.controls["iMaxMobile"].setValue(item.iMaxMobile);
    this.saveUser.controls["strUserName"].setValue(item.strUserName);
    this.editUserId = item.iSystemUser;
    this.editMod = true;
  }

  edit = async () => {
    var model = this.saveUser.value;
    model.iUserSystemUser = this.editUserId;
    if (!model.strFullName) {
      this.notifyService.showError("لطفا نام نام خانوادگی را وارد کنید");
      return;
    }

    if (!model.strPassword) {
      model.strPassword = "";
    }
    if (!model.iMaxInput) {
      this.notifyService.showError("لطفا حداکثر تعداد ورود را وارد کنید");
      return;
    }
    if (!model.iMaxMobile) {
      this.notifyService.showError("لطفا حداکثر تعداد خودود را وارد کنید");
      return;
    }

    const resp = await axios.post(`EditRadyabUser`, model);
    resp.data = JSON.parse(resp.data);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    else {
      this.notifyService.showSuccess(resp.data.strError);
      $('#addUser').modal('hide');
      this.getUser();
    }
  }

  goBack() {
    this._location.back();
  }

  assignCar = async (id: any) => {
    var model = {
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      iUserSystemUser: id
    }

    this.iUserSystemUser = id;
    this.otherService.Showspinner();
    const resp = await axios.post(`GetRadyabUserMobile`, model);
    this.otherService.nonespinner();

    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    else {
      this.assignCarList = JSON.parse(resp.data);

      this.countBHas = 0;
      this.assignCarList.forEach((element: any) => {
        this.countBHas += element.bHas;
      });

      this.fullAssignCarList = JSON.parse(resp.data);
    }
    this.assignCarList.sort((a: any, b: any) => {
      var textA = a.bHas;
      var textB = b.bHas;
      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
    });
  }

  addOrRemoveCar = async (id: any) => {
    var model = {
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      iUserSystemUser: this.iUserSystemUser,
      strUnitID: id,
    }
    const resp = await axios.post(`AddOrRemoveMobileFromUser`, model);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
  }

  access = async (id: any) => {

    this.iUserSystemUser = id;

    var model = this.otherService.stringNumberToNumber({

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: id

    })

    this.otherService.Showspinner();

    const resp = await axios.post(`GetRadyabUserAbility`, model);

    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    this.accessSystem = JSON.parse(resp.data);

    this.fullAccessSystem = JSON.parse(resp.data);

    this.fullAccessSystem = this.accessSystem.sort((a: any, b: any) => {

      var textA = a.bHas;

      var textB = b.bHas;

      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;

    });

  }

  addOrRemoveAccess = async (id: any) => {
    var model = {
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      iUserSystemUser: this.iUserSystemUser,
      strXenotakAbility: id,
    }
    const resp = await axios.post(`AddOrRemoveUserAbility`, model);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    else {
      // this.notifyService.showSuccess(resp.data.strError);

    }

  }

  filterAdd() {
    this.filterAddTh = !this.filterAddTh;
    if (this.filterAddTh) {
      this.assignCarList = this.fullAssignCarList.filter((el: any) => {
        return el.bHas != 0;
      });

    }
    else {
      this.assignCarList = this.fullAssignCarList;
    }

  }

  filterAddAccess() {
    this.filterAddTh = !this.filterAddTh;
    if (this.filterAddTh) {
      this.accessSystem = this.fullAccessSystem.filter((el: any) => {
        return el.bHas != 0;
      });

    }
    else {
      this.accessSystem = this.fullAccessSystem;
    }

  }

  addAllCar = async () => {
    let tempArray: any = [];
    let passingArray: any = [];
    tempArray = this.assignCarList.filter((x: any) => !x.bHas);
    tempArray.forEach((element: any) => {
      passingArray.push(element.strUnitID)
    });

    var model = {
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      iUserSystemUser: this.iUserSystemUser,
      lstUnitID: passingArray
    }

    const resp = await axios.post(`AddGroupMobilesFromUser`, model);
    // const resp = await axios.post(`AddOrRemoveAllMobileFromUser`, model);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    else {
      this.assignCarList.forEach((el: any) => {
        el.bHas = 1;
      });

    }
  }

  removeAllCar = async () => {
    let tempArray: any = [];
    let passingArray: any = [];
    tempArray = this.assignCarList.filter((x: any) => x.bHas);
    tempArray.forEach((element: any) => {
      passingArray.push(element.strUnitID)
    });
    var model = {
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      iUserSystemUser: this.iUserSystemUser,
      lstUnitID: passingArray,
    }
    const resp = await axios.post(`AddGroupMobilesFromUser`, model);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    else {
      this.assignCarList.forEach((el: any) => {
        el.bHas = 0;
      });
      // this.notifyService.showSuccess(resp.data.strError);
    }
  }

  addAllAccess = async () => {

    this.otherService.Showspinner();

    let strXenotakAbility: string[] = []

    from(this.fullAccessSystem).pipe(map((el: any) => el.strXenotakAbility), toArray()).subscribe({ next: val => strXenotakAbility = val })

    var model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: this.iUserSystemUser,

      bAddOrRemove: 1,

      lststrXenotakAbility: strXenotakAbility
    }

    const resp: any = await axios.post(`AddOrRemoveAllUserAbility`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.notifyService.showError(res.strError);

    if (resp.data.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    else {

      this.accessSystem.forEach((el: any) => {

        el.bHas = 1;

      });

      $('#access').modal('hide')

    }

  }

  removeAllAccess = async () => {

    this.otherService.Showspinner();

    let strXenotakAbility: string[] = []

    from(this.fullAccessSystem).pipe(map((el: any) => el.strXenotakAbility), toArray()).subscribe({ next: val => strXenotakAbility = val })

    var model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: this.iUserSystemUser,

      bAddOrRemove: 0,

      lststrXenotakAbility: strXenotakAbility

    }

    const resp = await axios.post(`AddOrRemoveAllUserAbility`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.notifyService.showError(res.strError);

    if (resp.data.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    else {

      this.accessSystem.forEach((el: any) => {

        el.bHas = 0;

      });

      $('#access').modal('hide')

    }
  }

  userHistory = async (id: any) => {

    this.userActivity = [];

    var model = {} as any;

    model.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

    model.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

    model.iLog_SystemUser = id;

    const resp = await axios.post(`GetRadyabUserLog`, model);

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    this.userActivity = JSON.parse(resp.data);

    this.fullUserActivity = JSON.parse(resp.data);

  }

  search(e: any) {
    this.userActivity = this.fullUserActivity.filter((el: any) => {

      return el.strActionType_strComment.includes(e.target.value);
    });
    if (this.userActivity.length == 0) {
      this.userActivity = this.fullUserActivity.filter((el: any) => {
        return el.strDate.includes(e.target.value);
      });
    }

  }

  openSubset_Modal(iSystemUser: number) {

    window.open(`saveUser/${iSystemUser}`, '_blank');

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'ExcelSheet.xlsx');
  }

  async getSubset(iSystemUser: number) {

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iLog_SystemUser: iSystemUser,

    })

    this.otherService.Showspinner();

    // let res = JSON.parse((await axios.post(`GetRadyabUserUsers`, model)).data.toString());
    let res: any = (await axios.post(`GetRadyabUserUsers_New`, model));

    this.otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (res.length == 0) return this.notifyService.showError('موردی یافت نشد')

    this.userList = res;

    this.fullUserList = res;

  }

  async getUserSchool(item: any, isSupervision?: 'supervision_service') {

    this.list_schools = [];

    this.iSystemUser_School = item.iSystemUser;

    var model = {

      iSystemUser_School: item.iSystemUser,

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let url = !this.bSchool ? 'MobileDomain_ListUserAccess' : 'School_MobileDomain_List';

    url = isSupervision ? 'SystemUser_MobileDomain_List' : url

    let res = JSON.parse((await axios.post(url, model)).data.toString());

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }


    this.list_schools = res;

    this.list_search = res;
  }

  async onCheckbox_(value: boolean, item: any, isSupervision?: 'supervision_service') {

    if (isSupervision) {

      var model = {

        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        iMobileDomain: item.iMobileDomain,

        iSystemUser_School: this.iSystemUser_School,

        bDelete: !value


      }

      let res = JSON.parse((await axios.post(`SystemUser_MobileDomain_SaveDelete`, model)).data.toString())

      if (res.iResult == 0) return this.notifyService.showError(res.strError)

      else return this.notifyService.showSuccess('عملیات با موفقیت انجام شد')

    }

    else {

      var model = {

        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        iMobileDomain: item.iMobileDomain,

        iSystemUser_School: this.iSystemUser_School,

        bDelete: !value


      }

      let res = JSON.parse((await axios.post(`School_User_SaveDelete`, model)).data.toString())

      if (res.iResult == 0) return this.notifyService.showError(res.strError)

      else return this.notifyService.showSuccess('عملیات با موفقیت انجام شد')

    }

  }

  async onClickMobileDomain(item: any, index: number) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: item.iMobileDomain,

      iUserSystemUser: this.iSystemUser_School,

    }

    let res: any = JSON.parse((await axios.post(`SystemUser_UpdateMobieDomain`, model)).data.toString())

    if (res.iResult == 0) return this.notifyService.showError(res.strError);

    $('#defineSchool').modal('hide');

    this.userList.filter((el: any) => el.iSystemUser == this.iSystemUser_School)[0].strMobile_strComment = item.strComment

    return this.notifyService.showSuccess('عملیات با موفقیت انجام شد')

  }

  async getUserGroup(item: any) {

    this.mdl_SystemUser_Group.patchValue({

      iUserSystemUser: item.iSystemUser,

      iSystemUser_Group: "",

    })

    $("#Access_Modal").modal('show')

  }

  async selectUserGroup(item: any) {

    this.mdl_SystemUser_Group.patchValue({

      iSystemUser_Group: item.iSystemUser_Group,

    })


    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`SystemUser_SetSystemUser_Group`, this.otherService.stringNumberToNumber(this.mdl_SystemUser_Group.value))).data.toString());

    this.otherService.nonespinner();

    if (res.iResult == 0) return this.notifyService.showSuccess(res.strError);

    this.notifyService.showSuccess('عملیات با موفقیت انجام شد');

    $("#Access_Modal").modal('hide');

    // 

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_schools = this.list_search.filter((el: any) => {

        return el.strComment?.includes(search) || el.strCityName?.includes(search)

      })
    }


    else if (search == '') this.list_schools = this.list_search

  }

  async getClassInitialize(item) {

    this.otherService.Showspinner();

    this.mdl_UserClass.patchValue({

      iUserSystemUser: item.iSystemUser,

    });

    await this.getUserSchool(item, 'supervision_service');

    if (!this.lst_Grade.length) {

      await this.getGradeList(item);

    }

    if (!this.lst_ClassNo.length) {

      await this.getClassNoList(item);

    }

    await this.openGradeClass(item);

    this.otherService.nonespinner();

  }

  async getGradeList(item: any) {

    this.mdl_SystemUser_Group.patchValue({

      iUserSystemUser: item.iSystemUser,

    })

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Grade_List`, this.otherService.stringNumberToNumber(this.mdl_SystemUser_Group.value))).data.toString());

    if (res.iResult == 0) return this.notifyService.showSuccess(res.strError);

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    this.lst_Grade = res;

  }

  async getClassNoList(item: any) {

    this.mdl_SystemUser_Group.patchValue({

      iUserSystemUser: item.iSystemUser,

    })

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`ClassNo_List`, this.otherService.stringNumberToNumber(this.mdl_SystemUser_Group.value))).data.toString());

    if (res.iResult == 0) return this.notifyService.showSuccess(res.strError);

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }


    this.lst_ClassNo = res;

  }

  async openGradeClass(item: any) {

    this.mdl_SystemUser_Group.patchValue({

      iUserSystemUser: item.iSystemUser,

    })


    let res = JSON.parse((await axios.post(`School_SystemUserGradeClass_List`, this.otherService.stringNumberToNumber(this.mdl_SystemUser_Group.value))).data.toString());

    if (res.iResult == 0) return this.notifyService.showSuccess(res.strError);

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    this.lst_GradeClass = res;

    $("#GradeClass_Modal").modal('show');


  }

  addUserClass() {

    this.mdl_UserClass.patchValue({

      iMobileDomain: '-1',

      tiGrade: '-1',

      tiClassNo: '-1',

    });

    $("#UserClassModal").modal('show')

  }

  async submitUserClass() {

    let model: any = this.mdl_UserClass.value;

    // model.iUserSystemUser = this.mdl_SystemUser_Group.get('iUserSystemUser')?.value;

    if (model.iMobileDomain == -1 || model.tiGrade == -1 || model.tiClassNo == -1) {

      return this.notifyService.showError('فرم را با دقت تکمیل کنید!')

    }

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_SystemUserGradeClass_Save`, this.otherService.stringNumberToNumber(model))).data.toString());

    this.otherService.nonespinner();

    if (res.iResult == 0) return this.notifyService.showSuccess(res.strError);

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    this.lst_GradeClass.push(res[0]);

    this.notifyService.showSuccess('با موفقیت ثبت شد.');

    $("#UserClassModal").modal('hide')


  }

  deleteGradeClass = async (id: any, index: number) => {

    $.confirm({

      title: `آیا از حذف اطمینان دارید؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {
              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
              iSchool_SystemUserGradeClass: id
            }

            const resp = await axios.post(`School_SystemUserGradeClass_Delete`, model);

            resp.data = JSON.parse(resp.data);

            if (resp.data.iResult == 0) {
              this.notifyService.showError(resp.data.strError);
              return;

            }

            if (resp.data.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              this.router.navigate(['login']);
              return;
            }

            else {

              this.notifyService.showSuccess("با موفقیت حذف شد");

              this.lst_GradeClass.splice(index, 1)

              // this.lst_GradeClass = this.lst_GradeClass.filter((el: any) => {

              //   return el.School_SystemUserGradeClass_Delete != id;

              // });


            }

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });




  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this.otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }


}
